import { render } from "./language-web.vue?vue&type=template&id=53520a30"
import script from "./language-web.vue?vue&type=script&lang=js"
export * from "./language-web.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__